module.exports = __webpack_public_path__ + "assets/42744f6065a30c0373f0f398038da20f.png";